import { ObstetricalFileType } from "@/Patient/Models/ObstetricalFile/Enum/ObstetricalFileType";
import { BritishColumbiaObstetricalFileFormCreator } from "./BritishColumbia/BritishColumbiaObstetricalFileFormCreator";
import { OntarioObstetricalFileFormCreator } from "./Ontario/OntarioObstetricalFileFormCreator";
import { QuebecObstetricalFileFormCreator } from "./Quebec/QuebecObstetricalFileFormCreator";
import { BaseObstetricalFormCreator } from "./BaseObstetricalFormCreator";

class ObstetricalFormCreatorFactory {
    public static forType(type: ObstetricalFileType): BaseObstetricalFormCreator | null {
        switch (type) {
            case ObstetricalFileType.OntarioForm:
                return new OntarioObstetricalFileFormCreator();
            case ObstetricalFileType.QuebecForm:
                return new QuebecObstetricalFileFormCreator();
            case ObstetricalFileType.BritishColumbiaForm:
                return new BritishColumbiaObstetricalFileFormCreator();
            default:
                return null;
        }
    }
}

export { ObstetricalFormCreatorFactory };
